"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBadgesByGameIdList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all badges assigned to a game with given ID (if it exists).
 *
 * Game is identified by its Steam ID.
 *
 * ### Filter options
 *
 * - `isLegacy` - filters by badge's `legacy` status,
 * - `isEnabled` - filters by badge's `enabled` status.
 *
 * ### Sort options
 *
 * - `points` - sorts by badge's point value.
 *
 * ## Usage
 *
 * ```ts
 * const gameId: number = 21645;
 * const badgesAll: Badge[] = await sdk.getBadgesByGameId({ gameId });
 * const badgePointsAsc: Badge[] = await sdk.getBadgesByGameId({ gameId, sort: { points: 'asc' }});
 * const badgesNonLegacy: Badge[] = await sdk.getBadgesByGameId({ gameId, filter: { isLegacy: false }});
 * ```
 *
 * // TODO currently this endpoint does not support non-Steam games as those don't have gameID.
 *
 * @param params.gameId - ID of the game which badges we want to retrieve.
 * @param params.filter - Filter to apply to returned badge list.
 * @param params.sort - Fields to sort badge list by.
 * @param params.limit - How many badges will get returned.
 */
const getBadgesByGameIdList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { gameId, filter, sort, limit } = params;
    const url = `${BASE_URL}/games/game/${gameId}/badges/list`;
    const badgeResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = badgeResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getBadgesByGameIdList = getBadgesByGameIdList;
